import { getInstance } from '@module-federation/runtime';
import type { ModuleFederation } from '@module-federation/runtime';

import entryFromPublicPath from '../../utils/parse-remote-entry';

export type DevRemoteConfig = {
  type: 'module';
  name: string;
  entry: string;
  entryGlobalName: string;
};

const KNOWN_DEV_REMOTES = [
  'customer-expense',
  'customer-pay-supplement',
  'customer-payroll',
] as const;
const HOST_FEDERATION_NAME = 'root-federation';

export const getHostFederationInstance = (): ModuleFederation | undefined =>
  getInstance((instance) => instance.options.name === HOST_FEDERATION_NAME) ??
  getInstance((instance) => Boolean(instance.options.name)) ??
  undefined;

export const createDevRemotes = (
  env: Record<string, string | undefined>,
): Record<string, DevRemoteConfig> => {
  const remotes: Record<string, DevRemoteConfig> = {};

  for (const name of KNOWN_DEV_REMOTES) {
    const entry = entryFromPublicPath(env, name);
    if (!entry) {
      continue;
    }
    remotes[name] = {
      type: 'module',
      name,
      entry,
      entryGlobalName: name,
    };
  }

  return remotes;
};

export const initializeRemotes = (
  env: Record<string, string | undefined>,
): void => {
  const remotes = Object.values(createDevRemotes(env));
  if (remotes.length === 0) {
    return;
  }

  const host = getHostFederationInstance();
  if (!host) {
    return;
  }

  host.registerRemotes(remotes);
};
